module.exports = __webpack_public_path__ + "img/deepsource-logo-centered.71abe12.webp";